import { render, staticRenderFns } from "./BottomTab.vue?vue&type=template&id=1602952f&scoped=true&"
import script from "./BottomTab.vue?vue&type=script&lang=ts&"
export * from "./BottomTab.vue?vue&type=script&lang=ts&"
import style0 from "./BottomTab.vue?vue&type=style&index=0&id=1602952f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1602952f",
  null
  
)

export default component.exports